export const SendQueueColumnNames = {
  resellerName: 'resellerName',
  id: 'id',
  status: 'status',
  smsText: 'smsText',
  sendType: 'sendType',
  sendSubType: 'sendSubType',
  creationLocation: 'creationLocation',
  senderNumber: 'senderNumber',
  dateTimeNext: 'dateTimeNext',
  failureCode: 'failureCode',
  userName: 'userName',
  organizationName: 'organizationName',
  created: 'created',
  description: 'description',
  title: 'title',
  campaignId: 'campaignId',
  referenceId: 'referenceId',
  recipientCount: 'recipientCount',
  voiceMessageId: 'voiceMessageId',
  fileLink: 'fileLink',
};
